import { render } from "./SingleSelect.vue?vue&type=template&id=783a1864&ts=true"
import script from "./SingleSelect.vue?vue&type=script&lang=ts"
export * from "./SingleSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__